<template>
  <Card id="ChildrenAbcScaleEdit" :dis-hover="true">
    <h4 slot="title" style="text-align: center">社会功能筛查量表测评报告</h4>

    <IForm ref="formInline" label-position="left" :model="formData" :submit="false"  @on-submit="toSubmit">
      <div>
        <div class="tableCell ivu-row" style="margin-left: -12px; margin-right: -12px;">
          <div class="col-cell ivu-col ivu-col-span-3" style="border: 1px solid rgba(0, 0, 0, 0.41); height: 40px; background-color: rgba(129, 211, 248, 0.298); line-height: 40px; padding-left: 12px; padding-right: 12px;">
            <div class="bgColor">姓名<span style="color: red;">*</span></div>
          </div>
          <div class="col-cell ivu-col ivu-col-span-5" style="border: 1px solid rgba(0, 0, 0, 0.41); height: 40px; background-color: rgb(255, 255, 255); line-height: 40px; padding-left: 2px; padding-right: 2px;">
            <div class="ivu-form-item">
              <div class="ivu-form-item-content">
                <div class="msg_box ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text">
                  <input v-model="formData.name" type="text" class="ivu-input ivu-input-default" style="width: 98%;margin-top: 3px;margin-left:2px;border: 1px solid #b3b3b3;" maxlength="50">
                </div>
              </div>
            </div>
          </div>
          <div class="col-cell ivu-col ivu-col-span-3" style="border: 1px solid rgba(0, 0, 0, 0.41); height: 40px; background-color: rgba(129, 211, 248, 0.298); line-height: 40px; padding-left: 12px; padding-right: 12px;">
            <div class="bgColor">性别<span style="color: red;">*</span></div>
          </div>
          <div class="col-cell ivu-col ivu-col-span-5" style="border: 1px solid rgba(0, 0, 0, 0.41); height: 40px; background-color: rgb(255, 255, 255); line-height: 40px; padding-left: 2px; padding-right: 2px;">
            <div class="ivu-form-item">
              <div class="ivu-form-item-content">
                <div class="msg_box ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text">
                  <i class="ivu-icon ivu-icon-ios-loading ivu-load-loop ivu-input-icon ivu-input-icon-validate"></i>
                  <Select v-model.number="formData.gender" style="width: 100px;">
                    <Option v-for="item in genderList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </div>
              </div>
            </div>
          </div>
          <div class="col-cell ivu-col ivu-col-span-3" style="border: 1px solid rgba(0, 0, 0, 0.41); height: 40px; background-color: rgba(129, 211, 248, 0.298); line-height: 40px; padding-left: 12px; padding-right: 12px;">
            <div class="bgColor">出生日期<span style="color: red;">*</span></div>
          </div>
          <div class="col-cell ivu-col ivu-col-span-5" style="border: 1px solid rgba(0, 0, 0, 0.41); height: 40px; background-color: rgb(255, 255, 255); line-height: 40px; padding-left: 2px; padding-right: 2px;">
            <div class="ivu-form-item">
              <div class="ivu-form-item-content">
                <div class="msg_box ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text">
                  <i class="ivu-icon ivu-icon-ios-loading ivu-load-loop ivu-input-icon ivu-input-icon-validate"></i>
                  <DatePicker v-model="formData.birthday" type="date" style="width:111px;" placeholder="出生日期" format="yyyy-MM-dd" @on-change="changeDate" :editable = "false"/>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="tableCell ivu-row" style="margin-left: -12px; margin-right: -12px;">
          <div class="col-cell ivu-col ivu-col-span-3" style="border: 1px solid rgba(0, 0, 0, 0.41); height: 40px; background-color: rgba(129, 211, 248, 0.298); line-height: 40px; padding-left: 12px; padding-right: 12px;">
            <div class="bgColor">年龄<span style="color: red;">*</span></div>
          </div>
          <div class="col-cell ivu-col ivu-col-span-5" style="border: 1px solid rgba(0, 0, 0, 0.41); height: 40px; background-color: rgb(255, 255, 255); line-height: 40px; padding-left: 2px; padding-right: 2px;">
            <div class="ivu-form-item">
              <div class="ivu-form-item-content">
                <div class="msg_box ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text">
                  <input v-model.number="formData.age" type="number" class="ivu-input ivu-input-default" style="width: 98%;margin-top: 3px;margin-left:2px;border: 1px solid #b3b3b3;" maxlength="2">
                </div>
              </div>
            </div>
          </div>
          <div class="col-cell ivu-col ivu-col-span-3" style="border: 1px solid rgba(0, 0, 0, 0.41); height: 40px; background-color: rgba(129, 211, 248, 0.298); line-height: 40px; padding-left: 12px; padding-right: 12px;">
            <div class="bgColor">
              与孩子关系<span style="color: red;">*</span>
            </div>
          </div>
          <div class="col-cell ivu-col ivu-col-span-5" style="border: 1px solid rgba(0, 0, 0, 0.41); height: 40px; background-color: rgb(255, 255, 255); line-height: 40px; padding-left: 2px; padding-right: 2px;">
            <div class="ivu-form-item">
              <div class="ivu-form-item-content">
                <div class="msg_box ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text">
                  <i class="ivu-icon ivu-icon-ios-loading ivu-load-loop ivu-input-icon ivu-input-icon-validate"></i>
                  <input v-model="formData.relation" type="text" class="ivu-input ivu-input-default" style="width: 98%;margin-top: 3px;margin-left:2px;border: 1px solid #b3b3b3;" maxlength="50">
                </div>
              </div>
            </div>
          </div>
          <div class="col-cell ivu-col ivu-col-span-3" style="border: 1px solid rgba(0, 0, 0, 0.41); height: 40px; background-color: rgba(129, 211, 248, 0.298); line-height: 40px; padding-left: 12px; padding-right: 12px;">
            <div class="bgColor">
              填报人<span style="color: red;">*</span>
            </div>
          </div>
          <div class="col-cell ivu-col ivu-col-span-5" style="border: 1px solid rgba(0, 0, 0, 0.41); height: 40px; background-color: rgb(255, 255, 255); line-height: 40px; padding-left: 2px; padding-right: 2px;">
            <div class="ivu-form-item">
              <div class="ivu-form-item-content">
                <div class="msg_box ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text">
                  <i class="ivu-icon ivu-icon-ios-loading ivu-load-loop ivu-input-icon ivu-input-icon-validate"></i>
                  <input v-model="formData.contactPerson" type="text" class="ivu-input ivu-input-default" style="width: 98%;margin-top: 3px;margin-left:2px;border: 1px solid #b3b3b3;" maxlength="50">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="tableCell ivu-row" style="margin-left: -12px; margin-right: -12px;">
          <div class="col-cell ivu-col ivu-col-span-3" style="border: 1px solid rgba(0, 0, 0, 0.41); height: 40px; background-color: rgba(129, 211, 248, 0.298); line-height: 40px; padding-left: 12px; padding-right: 12px;">
            <div class="bgColor">联系电话<span style="color: red;">*</span></div>
          </div>
          <div class="col-cell ivu-col ivu-col-span-5" style="border: 1px solid rgba(0, 0, 0, 0.41); height: 40px; background-color: rgb(255, 255, 255); line-height: 40px; padding-left: 2px; padding-right: 2px;">
            <div class="ivu-form-item">
              <div class="ivu-form-item-content">
                <div class="msg_box ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text">
                  <Input v-model="formData.phone" style="width: 98%;margin-top: 3px;margin-left:2px;border: 1px solid #b3b3b3;" @on-keyup="changephone(formData.phone, 'phone')" maxlength="12"/>
                </div>
              </div>
            </div>
          </div>
          <div class="col-cell ivu-col ivu-col-span-3" style="border: 1px solid rgba(0, 0, 0, 0.41); height: 40px; background-color: rgba(129, 211, 248, 0.298); line-height: 40px; padding-left: 12px; padding-right: 12px;">
            <div class="bgColor">幼儿园<span style="color: red;">*</span></div>
          </div>
          <div class="col-cell ivu-col ivu-col-span-13" style="border: 1px solid rgba(0, 0, 0, 0.41); height: 40px; background-color: rgb(255, 255, 255); line-height: 40px; padding-left: 2px; padding-right: 2px;">
            <div class="ivu-form-item">
              <div class="ivu-form-item-content">
                <div class="msg_box ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text">
                  <i class="ivu-icon ivu-icon-ios-loading ivu-load-loop ivu-input-icon ivu-input-icon-validate"></i>
                  <el-select v-model.trim="formData.kindergartenId" placeholder="幼儿园"
                             clearable filterable
                             size="small"
                             transfer="true"
                             :popper-append-to-body="false"
                             style="width: 98%;">
                    <el-option v-for="item in kindergartenList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id"
                               @click.native="handleKindergartenChange(item)"
                               style="width: 100%;z-index: 9999;"/>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <TableCell v-for="item in enums.problems" v-bind:key="item.code" :dataCol="[16,4,4]" :slotCount="3"  :bgBlue="[0]" :height="'60px'">
          <div slot="inner1" style="text-align: left;line-height: 30px;">{{item.label}}</div>
          <div v-for="(ans, index) in enums.answers" v-bind:key="ans.code" :slot="'inner'+ (index + 2)">
            <RadioGroup v-model="values[`value${item.code}`]">
              <Radio :label="ans.code">{{ans.value}}</Radio>
            </RadioGroup>
          </div>

        </TableCell>
      </div>

    </IForm>
  </Card>

</template>
<script>
import * as enums from "./enums"
import {_get, _save} from "@/services/autism/childrenAbcScale";
import {_kindergartens} from "@/services/manage/kindergartens";
import {_conrrentDate} from "@/services/common";

export default {
  name: "ChildrenAbcScaleEdit",
  data: () => ({
    enums: enums,
    values: enums.defaultValues,
    genderList: [
      {label: '男', value: 1},
      {label: '女', value: 2},
    ],
    formData:{
      id:"",
      medicalDate:"",
      kindergartenId:"",
      name:"",
      gender:"",
      age:"",
      birthday:"",
      contactPerson:"",
      relation:"",
      phone:"",
      problem:"",
      otherQuestions:"",
      remark:"",
    },
    kindergartenList: [],
    conrrentDate: "",
  }),
  created() {
    this.conrrentDate = new Date();
    this.$nextTick(()=>{
      this.getConrrentDate();
    })
  },
  mounted() {
    if (!this.$userSession.checkInstitutionId()){
      return;
    }
    this.kindergartens();
  },
  methods: {
    scrollToTop(){
      this.$nextTick(() => {
        this.$el.scrollTop = 0;
      });
    },
    changeDate(e){
      this.formData.birthday = e
      this.confirmToBirthdayDate();
    },
    confirmToBirthdayDate(){
      let _birthday = this.formData.birthday.split("-");
      let _year = _birthday[0];
      let _month = _birthday[1];
      let _day = _birthday[2];

      let date = this.conrrentDate;
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      var day = date.getDate();

      let age = parseInt(year) - parseInt(_year);
      if (month < _month || (month === _month && day < _day)) {
        age--;
      }
      this.formData.age = age;
    },
    handleKindergartenChange(item) {
      this.formData.kindergartenId = item.id;
    },
    kindergartens(){
      _kindergartens().then(res => {
        if (res && res.errcode && res.errcode === 1){
          this.kindergartenList = res.data;
        }
      }).catch(() => {});
    },
    handleModal(isCreate, title, row) {
      if (isCreate) {
        this.handleCreate();
      } else {
        this.handleEdit(row);
      }
      this.$forceUpdate();
    },
    handleCreate() {
      this.formData = Object.assign({}, this.formData);
    },
    handleEdit(row) {
      _get({id:row.id}).then(res => {
        if (res && res.errcode === 1 && res.data) {
          this.formData = res.data;
          if(this.formData.problem){
            let _values = this.formData.problem.split(",");
            for (let i = 0; i < _values.length; i++) {
              this.values[`value${i + 1}`] = parseInt(_values[i]);
            }
          }
        }
      })
    },
    reset(){
      this.formData = {
          medicalDate:"",
          kindergartenId:"",
          name:"",
          gender:"",
          age:"",
          birthday:"",
          contactPerson:"",
          relation:"",
          phone:"",
          problem:"",
          otherQuestions:"",
          remark:"",
      };

      for (let index = 1; index <= this.enums.problems.length; index++) {
        this.values['value' + index] = "";
      }
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      if(!this.formData.name){
        this.$message.warning("请填写姓名");
        return;
      }else if(!this.formData.gender){
        this.$message.warning("请选择性别");
        return;
      }else if(!this.formData.birthday){
        this.$message.warning("请填写出生日期");
        return;
      }else if(this.formData.age.length === 0){
        this.$message.warning("请填写年龄");
        return;
      }else if(!this.formData.relation){
        this.$message.warning("请填写与孩子关系");
        return;
      }else if(!this.formData.contactPerson){
        this.$message.warning("请填写填报人");
        return;
      }else if(!this.formData.phone){
        this.$message.warning("请填写联系电话");
        return;
      }else if(!this.formData.kindergartenId){
        this.$message.warning("请选择幼儿园");
        return;
      }

      let indexArr = "";
      for (let index = 1; index <= this.enums.problems.length; index++) {
        let indexValue = this.values['value' + index];
        if(!indexValue || indexValue.length === 0){
          this.$message.warning("第" +  index + "项 题目还未选择!");
          return;
        }
        indexArr += indexValue
        if (index < this.enums.problems.length) {
          indexArr += ","
        }
      }

      if(this.formData.birthday.toString().length > 10){
        let birthday = this.formData.birthday;
        let year = birthday.getFullYear();
        let month = birthday.getMonth() + 1;
        let day = birthday.getDate();
        this.formData.birthday = year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
      }

      this.formData.problem = indexArr;
      _save(this.formData).then(res => {
        if (res.errcode === 1) {
          this.$emit("on-submit");
          this.$message.success("保存成功");
        } else {
          this.$message.error(res.errmsg);
        }
      }).catch(() => {
      });
    },
    getConrrentDate() {
      _conrrentDate().then(res => {
        if (res && res.errcode === 1 && res.data) {
          this.conrrentDate = new Date(res.data);
        }
      })
    },
    importData(data){
      this.form = data;
    },
    exportData(){
      return this.form;
    },
    clearData(){

    },
    changephone(value, AttrName) {
      this.formData[AttrName] = value;
      this.formData[AttrName] = this.formData[AttrName].replace(/[^\d-]/g, '');
      this.formData[AttrName] = this.formData[AttrName].replace(',', '');
      this.formData[AttrName] = this.formData[AttrName].replace('，', '');
      this.formData[AttrName] = this.formData[AttrName].replace(/^-/g, '');
      // 保证只有出现一个-而没有多个-
      this.formData[AttrName] = this.formData[AttrName].replace(/-{2,}/g, '');
      // 保证.只出现一次，而不能出现两次以上
      this.formData[AttrName] = this.formData[AttrName].replace('-', '$#$').replace(/-/g, '').replace('$#$', '-');

    },
  }
};
</script>
<style lang="postcss" scoped>
#careTable{
  font-size: 13px!important;
}
/deep/ .ivu-radio-group-item{
  font-size:13px;
}
.cell {
  position: relative;
  line-height: 32px;
  font-size: 13px;
}

/deep/ .ivu-input {
  //border: 0 none;
  //border-bottom: 1px solid #b3b3b3;
  border-radius: 0px;
}

/deep/ .ivu-input-disabled {
  background-color: white;
}
/deep/.ivu-input[disabled], fieldset[disabled] .ivu-input{
  color: rgba(46, 46, 46, 0.83);
}
</style>
